module.exports = __webpack_public_path__ + "media/components/settings/images/wmhw-dbd0d521f458fc48f523d0dd2f8df32a.png";